import { Authorization } from 'glxl-helpers';
import {
  LOGOUT_USER,
  UPDATE_USER,
} from '../actions/types';

const auth = new Authorization();

const initialState = {
  projectId: null,
  userDetails: null,
  loggedIn: false,
  token: null,
  role: null,
  feedback: [],
};

const user = (state = initialState, action) => {
  const { payload, type } = action;
  switch (type) {
    case LOGOUT_USER:
      if (sessionStorage.getItem('token')) {
        sessionStorage.removeItem('token');
        window.close();
      } else {
        auth.setAuthToken('');
        // cookie.setCookie('i18n', '');
        sessionStorage.removeItem('redirect');
        sessionStorage.removeItem('prevLocation');
        sessionStorage.removeItem('noMobile');
        window.location.href = '/login';
      }
      return initialState;
    case UPDATE_USER:
      if (!payload.userDetails.role) {
        throw new Error('User has no role.');
      }
      return {
        ...state,
        userDetails: mapUserDetails(payload.userDetails),
        token: payload.token,
        loggedIn: true,
        role: payload.userDetails.role,
      };
    default:
      return state
  }
};

const mapUserDetails = (data) => {
  const mapped = {
    ...data,
    group: data.ownedGroup ? data.ownedGroup : data.group,
    schoolClass: null,
  };
  if (mapped.group) {
    mapped.schoolClass = mapped.group.SchoolClass;
  }
  return mapped;
};

export default user;



// WEBPACK FOOTER //
// ./src/reducers/user.js